export default {
  speakerIcon: {
    fontSize: '25px',
    marginTop: '-7px',
  },
};
